document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.shopify-section');

  sections.forEach((section) => {
    const hasCollectionCards = section.querySelector('.collection-item');
    const hasProductCards = section.querySelector('.grid-product');

    if (!hasCollectionCards || hasProductCards) return;

    const grid = section.querySelector('.grid.grid--uniform');
    if (!grid) return;

    if (grid.dataset.nestevaArrowsInit === 'true') return;
    grid.dataset.nestevaArrowsInit = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'nesteva-collections-wrap';

    grid.parentNode.insertBefore(wrapper, grid);
    wrapper.appendChild(grid);

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'nesteva-collections-arrow nesteva-collections-arrow--prev';
    prev.setAttribute('aria-label', 'Stânga');
    prev.innerHTML = '‹';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'nesteva-collections-arrow nesteva-collections-arrow--next';
    next.setAttribute('aria-label', 'Dreapta');
    next.innerHTML = '›';

    wrapper.appendChild(prev);
    wrapper.appendChild(next);

    const updateArrows = () => {
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      const desktop = window.innerWidth >= 769;

      prev.style.display = desktop ? 'flex' : 'none';
      next.style.display = desktop ? 'flex' : 'none';

      prev.disabled = grid.scrollLeft <= 4;
      next.disabled = grid.scrollLeft >= maxScroll - 4;
    };

    prev.addEventListener('click', () => {
      grid.scrollBy({ left: -320, behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      grid.scrollBy({ left: 320, behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  });
});